import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import dayjs from "dayjs";
import AppBar from "../../components/atoms/appbar";
import CompetitionRankingBoard from "./components/CompetitionRankingBoard";
import { useTournamentDetail } from "../../@apis/hooks/useTournament";
import { useGetRoundList } from "../../@apis/hooks/useScore";

export default function CompetitionRanking() {
  const { id } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // 대회 정보(이름/일정)
  const { data: detailRes } = useQuery({
    ...useTournamentDetail(id as string),
    enabled: !!id,
  });
  const info = detailRes?.data?.tournamentInfo;

  // 라운드 목록으로 대회 유형 판별: 라운드가 있으면 MULTI_ROUND, 없으면 LEGACY
  const { data: roundListRes } = useQuery({
    ...useGetRoundList(id ?? null),
    enabled: !!id,
  });
  const roundList = roundListRes?.data?.roundList ?? [];
  const tournamentType = roundList.length > 0 ? "MULTI_ROUND" : "LEGACY";

  // 대회 진행 상태
  const now = dayjs();
  const statusLabel = info
    ? now.isAfter(dayjs(info.endDt))
      ? "대회 종료"
      : now.isBefore(dayjs(info.startDt))
        ? "대회 예정"
        : "대회 진행중"
    : "";

  // 새로고침: 순위/스코어카드 관련 쿼리 무효화 + 아이콘 1회 회전
  const [spinKey, setSpinKey] = useState<number | null>(null);
  const handleRefresh = () => {
    setSpinKey(Date.now());
    [
      "score-order-list",
      "round-score-order-list",
      "score-card-view",
      "user-score-cards",
    ].forEach((key) => queryClient.invalidateQueries({ queryKey: [key] }));
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <AppBar
        title="대회 순위"
        backButton
        onBack={() => navigate(-1)}
        right={
          <button
            aria-label="새로고침"
            onClick={handleRefresh}
            className="grid place-items-center size-[24px]"
          >
            <img
              key={spinKey ?? "idle"}
              className={`size-[22px] ${spinKey ? "animate-[spin_0.6s_linear]" : ""}`}
              onAnimationEnd={() => setSpinKey(null)}
              src="/icons/ic-refresh.png"
              alt="새로고침"
            />
          </button>
        }
      />

      {/* 순위 콘텐츠 (이 페이지 전용 표 디자인) */}
      <CompetitionRankingBoard
        tournamentId={info?.id ?? (id ? Number(id) : null)}
        tournamentType={tournamentType}
        tournamentName={info?.name}
        statusLabel={statusLabel}
      />
    </div>
  );
}
